import { Box } from 'lucide-react';
import { GuideCategory } from './types';

export const simulationModesGuide: GuideCategory = {
  id: 'simulation-modes',
  title: 'Ball Engine Modes',
  icon: Box,
  articles: [
    {
      slug: 'rhythmic-mode',
      title: 'Rhythmic Ball Physics',
      description: 'The easiest way to sync your ball bouncing simulator with music.',
      sections: [
        {
          id: 'audio-sync',
          title: 'How Music Sync Works',
          content: 'In Rhythmic mode, the ball physics react directly to the audio beat. When the bass drops or the melody pulses, the ball engine triggers bounces or size shifts in perfect time.',
          tips: ['High-energy tracks with clear drums create the most satisfying rhythmic ball simulations.']
        }
      ]
    },
    {
      slug: 'escape-mode',
      title: 'Escape & Survival',
      description: 'The interactive "game" mode where your balls must survive obstacles.',
      sections: [
        {
          id: 'survival-logic',
          title: 'How to Play Escape Mode',
          content: 'In this mode, your balls are trying to avoid being hit by obstacles or captured by "gravity wells". You can influence their path by clicking and dragging on the screen.',
          tips: ['Use the "Attractor" tool to pull balls away from danger zones.']
        },
        {
          id: 'obstacle-settings',
          title: 'Customizing Obstacles',
          content: 'Change the speed and size of the obstacles. Higher settings turn your ball engine on browser into a high-intensity survival game.'
        }
      ]
    },
    {
      slug: 'spawner-mode',
      title: 'Beautiful Ball Spawners',
      description: 'Creating automated ball emitters for mesmerizing visual patterns.',
      sections: [
        {
          id: 'emitters',
          title: 'Using Ball Emitters',
          content: 'Emitters are where the balls are born in your simulation. You can place them anywhere and configure how they fire balls into the engine to create complex, geometric patterns.',
          settingId: 'emitter_controls'
        },
        {
          id: 'spawn-rate',
          title: 'Controlling Spawn Speed',
          content: 'Adjust how many balls enter the engine per second. Be careful: too many balls can create chaos (though sometimes that\'s exactly what you want!).',
          tips: ['Lower the gravity when using high spawn rates to create a "floating nebula" effect.']
        }
      ]
    },
    ...(import.meta.env.DEV ? [
      {
        slug: 'spacespiral-mode',
        title: 'SpaceSpiral Geometry',
        description: 'Create swirling, infinite patterns with spiral ball physics.',
        sections: [
          {
            id: 'spiral-force',
            title: 'The Centripetal Force',
            content: 'Adjust the "Spiral Pull" to keep balls orbiting the center point. This mode is perfect for creating satisfying, infinite loop videos.',
            tips: ['Set the trail length to "Infinite" in the Visuals tab for a stunning geometric drawing.']
          }
        ]
      }
    ] : [])
  ]
};
